// extracted by mini-css-extract-plugin
export default {"metrics":"Resizer-module_metrics_XtJNv","resizer":"Resizer-module_resizer_YNDJp"};